function generateRandomArray(n, max) {
  // Create an array with numbers from 0 to max (inclusive)
  const allNumbers = Array.from({ length: max + 1 }, (_, index) => index);

  // Fisher-Yates shuffle to randomize the array
  for (let i = allNumbers.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [allNumbers[i], allNumbers[j]] = [allNumbers[j], allNumbers[i]];
  }

  // Return the first n elements of the shuffled array
  return allNumbers.slice(0, n);
}

const productsCategories = [
  {
    id: 0,
    name: "Computers & Categories",
  },
  {
    id: 1,
    name: "Mobile & Accessories",
  },
  {
    id: 2,
    name: "Home & Kitchen",
  },
  {
    id: 3,
    name: "Clothing & Accessories",
  },
  {
    id: 4,
    name: "Furniture",
  },
];
const products = [
  {
    id: 0,
    name: "Acer Laptop",
    category: "Computers & Categories",
    title:
      "Acer Predator Helios 16 Gaming Laptop | 13th Gen Intel Core i7-13700HX | NVIDIA GeForce RTX 4060 | 16 2560 x 1600 165Hz G-SYNC Display | 16GB DDR5 | 1TB Gen 4 SSD | Killer Wi-Fi 6E | PH16-71-74UU",
    rating: "★★★★✰",
    price: "1,80,990",
    mrp: "2,07,999",
    discount: "11%",
    isEMI: true,
    EMI: "6,885",
    delivery_day: "Friday, 24 November",
    is360: false,
    specs: [
      { title: "Brand", desc: "Acer" },
      { title: "Model Name", desc: "Predator Helios 16" },
      { title: "Screen Size", desc: "16 Inches" },
      { title: "Colour", desc: "grey" },
      { title: "CPU Model", desc: "Core i7" },
      { title: "RAM Memory Installed Size", desc: "16 GB" },
      { title: "Operating System", desc: "Windows 11 Home" },
      { title: "Graphics Card Desciption", desc: "Thin" },
      { title: "Graphics Coprocessor", desc: "Dedicated" },
    ],
    about: [
      "Next Gen Performance: Intel Core i7-13700HX processor Mobile Intel HM770 PCH Chipset",
      "Internal Specifications: Dual-channel DDR5 SDRAM support 16 (2*8) GB of DDR5 system memory, Upgradable up to 32 GB of DDR5 system memory.Storage: 1 TB, PCIe Gen4, 16 Gb/s, NVMe",
      "Display:16.0 display with IPS (In-Plane Switching) technology, WQXGA 2560 x 1600, high-brightness (500 nits) Acer ComfyView LED-backlit TFT LCD,supporting 165 Hz, Grey to Grey 3 ms by Overdrive, Nvidia Advanced Optimus capable",
      "Graphics: NVIDIA GeForce RTX 4060 with 8 GB of dedicated GDDR6 VRAM",
      "Other Features: NVIDIA Advance Optimus, 5th Gen Aeroblade 3D Fan, Full Function Thunderbolt-4",
    ],
  },
  {
    id: 1,
    name: "Apple Phone",
    category: "Mobile & Accessories",
    title: "Apple iPhone 14 Pro Max (1 TB) - Deep Purple",
    rating: "★★★★✰",
    price: "1,89,900",
    mrp: "2,19,900",
    discount: "17%",
    isEMI: true,
    EMI: "9,208",
    delivery_day: "Monday, 27 November",
    is360: false,
    specs: [
      { title: "Brand", desc: "Apple" },
      { title: "Model Name", desc: "iPhone" },
      { title: "Network Servce Provider", desc: "Unlocked for All Carriers" },
      { title: "Colour", desc: "deep purple" },
      { title: "Operating System", desc: "IOS" },
      { title: "Cellular Technology", desc: "5G" },
    ],
    about: [
      "17.00 cm (6.7-inch) Super Retina XDR display featuring Always-On and ProMotion",
      "Dynamic Island, a magical new way to interact with iPhone",
      "48MP Main camera for up to 4x greater resolution",
      "Action mode for smooth, steady, handheld videos",
      "All-day battery life and up to 29 hours of video playback",
      "Vital safety technology — Crash Detection can detect a severe car crash and call for help",
    ],
  },
  {
    id: 2,
    name: "Dell Laptop",
    category: "Computers & Categories",
    title:
      "Dell Inspiron 15 Pro Laptop | 12th Gen Intel Core i5-12600H | NVIDIA GeForce GTX 3050 | 15.6-inch FHD Display | 8GB DDR4 | 512GB SSD | Windows 10",
    rating: "★★★★★",
    price: "95,999",
    mrp: "1,12,499",
    discount: "15%",
    isEMI: true,
    EMI: "3,650",
    delivery_day: "Wednesday, 22 November",
    is360: false,
    specs: [
      { title: "Brand", desc: "Dell" },
      { title: "Model Name", desc: "Inspiron 15 Pro" },
      { title: "Screen Size", desc: "15.6 Inches" },
      { title: "Colour", desc: "silver" },
      { title: "CPU Model", desc: "Core i5" },
      { title: "RAM Memory Installed Size", desc: "8 GB" },
      { title: "Operating System", desc: "Windows 10" },
      { title: "Graphics Card Desciption", desc: "Discrete" },
      { title: "Graphics Coprocessor", desc: "NVIDIA GTX 3050" },
    ],
    about: [
      "Powerful Performance: Intel Core i5-12600H processor with high-speed processing capabilities.",
      "Memory and Storage: 8GB DDR4 RAM for seamless multitasking, 512GB SSD for fast data access.",
      "Vibrant Display: 15.6-inch FHD display for clear visuals and an immersive viewing experience.",
      "Graphics: NVIDIA GeForce GTX 3050 with 4GB GDDR5 VRAM for smooth gaming and graphics-intensive tasks.",
      "Operating System: Pre-installed Windows 10 for a user-friendly experience.",
    ],
  },
  {
    id: 3,
    name: "HP Laptop",
    category: "Computers & Categories",
    title:
      "HP Spectre x360 Convertible Laptop | 11th Gen Intel Core i7-1165G7 | Intel Iris Xe Graphics | 13.3-inch 4K OLED Display | 16GB DDR4 | 1TB SSD | Windows 11",
    rating: "★★★★✰",
    price: "1,49,999",
    mrp: "1,69,999",
    discount: "12%",
    isEMI: true,
    EMI: "5,750",
    delivery_day: "Monday, 20 November",
    is360: false,
    specs: [
      { title: "Brand", desc: "HP" },
      { title: "Model Name", desc: "Spectre x360" },
      { title: "Screen Size", desc: "13.3 Inches" },
      { title: "Colour", desc: "black" },
      { title: "CPU Model", desc: "Core i7" },
      { title: "RAM Memory Installed Size", desc: "16 GB" },
      { title: "Operating System", desc: "Windows 11" },
      { title: "Graphics Card Desciption", desc: "Integrated" },
      { title: "Graphics Coprocessor", desc: "Intel Iris Xe Graphics" },
    ],
    about: [
      "Versatile Design: Convertible laptop with a 360-degree hinge for multiple usage modes.",
      "High-Resolution Display: 13.3-inch 4K OLED display for stunning visuals and vibrant colors.",
      "Powerful Performance: Intel Core i7-1165G7 processor for fast and efficient computing.",
      "Ample Storage: 1TB SSD for ample storage space and fast data access.",
      "Premium Build: Sleek and durable design with a premium aluminum finish.",
    ],
  },
  {
    id: 4,
    name: "Samsung Refrigerator",
    category: "Home & Kitchen",
    title:
      "Samsung Refrigerator | 23 cu. ft. | Stainless Steel | Digital Inverter Compressor | LED Lighting | Energy Star Certified",
    rating: "★★★★★",
    price: "65,499",
    mrp: "74,999",
    discount: "13%",
    isEMI: true,
    EMI: "2,500",
    delivery_day: "Thursday, 23 November",
    is360: false,
    specs: [
      { title: "Brand", desc: "Samsung" },
      { title: "Capacity", desc: "23 cu. ft." },
      { title: "Color", desc: "Stainless Steel" },
      { title: "Compressor Type", desc: "Digital Inverter" },
      { title: "Lighting", desc: "LED" },
      { title: "Certification", desc: "Energy Star Certified" },
    ],
    about: [
      "Ample Storage: 23 cubic feet capacity to store a large quantity of food and beverages.",
      "Energy Efficiency: Digital Inverter Compressor for energy-efficient and quiet operation.",
      "Bright Interior: LED lighting for better visibility and energy savings.",
      "Modern Design: Stainless steel finish for a sleek and commercial look.",
      "Environmentally Friendly: Energy Star Certified for reduced energy consumption.",
    ],
  },
  {
    id: 5,
    name: "WP Washing Machine",
    category: "Home & Kitchen",
    title:
      "Whirlpool Washing Machine | 15kg Capacity | Front Load | In-Built Heater | 12 Wash Programs | Digital Display",
    rating: "★★★★✰",
    price: "48,999",
    mrp: "54,999",
    discount: "10%",
    isEMI: true,
    EMI: "2,000",
    delivery_day: "Tuesday, 21 November",
    is360: false,
    specs: [
      { title: "Brand", desc: "Whirlpool" },
      { title: "Capacity", desc: "15kg" },
      { title: "Loading Type", desc: "Front Load" },
      { title: "Heater", desc: "In-Built" },
      { title: "Wash Programs", desc: "12" },
      { title: "Display", desc: "Digital" },
    ],
    about: [
      "Large Capacity: 15kg capacity suitable for commercial laundry needs.",
      "Efficient Washing: Front load design for better cleaning and water efficiency.",
      "Temperature Control: In-built heater for hot water wash and better stain removal.",
      "Versatile Programs: 12 wash programs to accommodate various fabric types.",
      "User-Friendly: Digital display for easy program selection and monitoring.",
    ],
  },
  {
    id: 6,
    name: "Panasonic Oven",
    category: "Home & Kitchen",
    title:
      "Panasonic Microwave Oven | 1.6 cu. ft. | 1200W | Touch Control Panel | Stainless Steel Interior | Multi-Stage Cooking",
    rating: "★★★★★",
    price: "12,999",
    mrp: "14,999",
    discount: "13%",
    isEMI: true,
    EMI: "550",
    delivery_day: "Monday, 20 November",
    is360: false,
    specs: [
      { title: "Brand", desc: "Panasonic" },
      { title: "Capacity", desc: "1.6 cu. ft." },
      { title: "Power", desc: "1200W" },
      { title: "Control Panel", desc: "Touch" },
      { title: "Interior", desc: "Stainless Steel" },
      { title: "Cooking Modes", desc: "Multi-Stage" },
    ],
    about: [
      "Spacious Interior: 1.6 cubic feet capacity for cooking large dishes.",
      "High Power: 1200W for quick and efficient cooking.",
      "Easy Operation: Touch control panel for intuitive operation.",
      "Durable Interior: Stainless steel interior for easy cleaning and longevity.",
      "Versatile Cooking: Multi-stage cooking for precise control over cooking stages.",
    ],
  },
  {
    id: 7,
    name: "Sony Headset",
    category: "Computers & Categories",
    title: "Sony Noise-Canceling Wireless Headset WH-1000XM4",
    rating: "★★★★★",
    price: "24,999",
    mrp: "29,999",
    discount: "17%",
    isEMI: false,
    EMI: "950",
    delivery_day: "Wednesday, 22 November",
    is360: false,
    specs: [
      { title: "Brand", desc: "Sony" },
      { title: "Model", desc: "WH-1000XM4" },
      { title: "Type", desc: "Over-Ear Wireless" },
      { title: "Noise-Canceling", desc: "Yes" },
      { title: "Battery Life", desc: "Up to 30 hours" },
      { title: "Connectivity", desc: "Bluetooth 5.0" },
      { title: "Color", desc: "Black" },
    ],
    about: [
      "Industry-Leading Noise Cancellation: Advanced noise-canceling technology for a distraction-free listening experience.",
      "Exceptional Sound Quality: High-resolution audio with powerful and clear sound reproduction.",
      "Long Battery Life: Up to 30 hours of playtime on a single charge for all-day use.",
      "Comfortable Design: Plush ear cushions and a lightweight build for extended wearing comfort.",
      "Smart Touch Controls: Intuitive touch controls for easy music playback and call management.",
      "Bluetooth Connectivity: Seamless pairing with Bluetooth-enabled devices for wireless convenience.",
    ],
  },
  {
    id: 8,
    category: "Clothing & Accessories",
    name: "Fossil Smartwatch",
    title: "Fossil Gen 6 Smartwatch",
    rating: "★★★★★",
    price: "21,499",
    mrp: "24,999",
    discount: "14%",
    isEMI: false,
    EMI: "825",
    delivery_day: "Thursday, 23 November",
    is360: false,
    specs: [
      { title: "Brand", desc: "Fossil" },
      { title: "Model", desc: "Gen 6" },
      { title: "Type", desc: "Smartwatch" },
      { title: "Display", desc: "1.28-inch AMOLED" },
      { title: "Compatibility", desc: "iOS, Android" },
      { title: "Connectivity", desc: "Bluetooth, Wi-Fi" },
      { title: "Water Resistance", desc: "5 ATM" },
      { title: "Color", desc: "Silver" },
    ],
    about: [
      "Advanced Smart Features: Fossil Gen 6 with cutting-edge smartwatch capabilities.",
      "Vibrant Display: 1.28-inch AMOLED display for clear visuals and vibrant colors.",
      "Cross-Platform Compatibility: Works seamlessly with both iOS and Android devices.",
      "Connectivity Options: Bluetooth and Wi-Fi connectivity for versatile usage.",
      "Water-Resistant Design: 5 ATM water resistance for protection against splashes and rain.",
      "Customizable Straps: Interchangeable straps to match your style and outfit.",
      "Fitness Tracking: Built-in fitness features for tracking your workouts and health.",
    ],
  },
  {
    id: 9,
    name: "Samsonite Laptop Bag",
    category: "Computers & Categories",
    title: "Samsonite Pro-DLX 5 Laptop Backpack",
    rating: "★★★✰✰",
    price: "5,999",
    mrp: "6,999",
    discount: "14%",
    isEMI: false,
    EMI: "230",
    delivery_day: "Friday, 24 November",
    is360: false,
    specs: [
      { title: "Brand", desc: "Samsonite" },
      { title: "Model", desc: "Pro-DLX 5" },
      { title: "Type", desc: "Laptop Backpack" },
      { title: "Material", desc: "Durable Nylon" },
      { title: "Laptop Compartment", desc: "Up to 15.6 inches" },
      { title: "Color", desc: "Black" },
      { title: "Number of Compartments", desc: "Multiple" },
      { title: "Special Features", desc: "USB Charging Port, TSA Lock" },
    ],
    about: [
      "Premium Quality: Samsonite Pro-DLX 5 made with high-quality and durable nylon material.",
      "Spacious Design: Multiple compartments for organized storage of laptop, documents, and accessories.",
      "Laptop Protection: Dedicated compartment for laptops up to 15.6 inches for secure and padded storage.",
      "Convenient Charging: Built-in USB charging port for on-the-go device charging.",
      "Secure Travel: TSA-approved lock for added security during travel.",
      "Comfortable Wear: Padded shoulder straps and back panel for a comfortable carrying experience.",
      "Professional Look: Stylish black design suitable for both casual and professional settings.",
    ],
  },
  {
    id: 10,
    name: "6-Seater Dining Table",
    category: "Furniture",
    title:
      "Home Centre Diana 6-Seater Dining Table with 4 Chairs and 1 Big Bench (Walnut)",
    rating: "★★★★✰",
    price: "21,950",
    mrp: "59,991",
    discount: "63%",
    isEMI: true,
    EMI: "1,064",
    delivery_day: "Friday, 12 January",
    is360: false,
    specs: [
      { title: "Colour", desc: "Brown" },
      { title: "Brand", desc: "Home Centre" },
      {
        title: "Size",
        desc: "6 Seater Dining Table with 4 Chairs and 1 Bench",
      },
      { title: "Item Dimensions LxWxH", desc: "150 x 90 x 74 Centimeters" },
      { title: "Laptop Compartment", desc: "Up to 15.6 inches" },
      { title: "Material", desc: "Beech" },
    ],
    about: [
      "Dimension : Dining Table : 150 cm x 90 cm x 74 cm, Dining Chair : 51.5 cm x 45 cm x 96.5 cm, Dining Bench : 120 cm x 38 cm x 48 cm.",
      "Table is made of Solid Beech Wood & particle board tabletop with Beech Veneer.",
      "Dining bench is made of Solid Beech frame & Upholstered cushion Seat.",
      "Chair is made of Solid Beech frame & Upholstered cushion Seat",
      "Finish : Veneer, Share : Rectangular",
    ],
  },
  {
    id: 11,
    name: "Double Bed",
    category: "Furniture",
    title:
      "Wakefit Bed | 1 Year Warranty | Double Bed, Queen Size Bed, Taurus Engineered Wood Bed with Storage, Wooden Bed (Matte Finish_Brown)",
    rating: "★★★★★",
    price: "11,615",
    mrp: "13,200",
    discount: "12%",
    isEMI: true,
    EMI: "563",
    delivery_day: "17 - 22 January",
    is360: false,
    specs: [
      { title: "Size", desc: "Queen" },
      { title: "Special Feature", desc: "Storage, Sturdy" },
      { title: "Colour", desc: "Brown" },
      { title: "Product Dimensions", desc: "2.1L x 1.57W x 0.8H Meters" },
      { title: "Brand", desc: "Wakefit" },
      { title: "Finish Type", desc: "Matte" },
      { title: "Material", desc: "Engineered Wood" },
    ],
    about: [
      "Installation/Assembly will be done within 4 working days of delivery",
      "CARE INSTRUCTIONS: Clean the surface with a dry cloth once a week.",
      "Strong 18mm Engineered Wood Particle Board used; For bed base - Top 11mm MDF ; Bottom - MDF boards; The sheet has been designed specifically to be water resistant and withstand more uniform load",
      "PRODUCT DIMENSIONS: Length: 209.7cm, Width: 156.9cm, Height : 79.5cm / 78 x 60 x 30 inches / 6.5 x 5 x 2.5 feet",
      "PHYSICAL ATTRIBUTES: Product Color: Columbian Walnut | Product Weight: 99.3kg",
      "Frame Material: 18mm Engineered Wood (Sturdy and best-in-class).",
      "Warranty: 1 year on manufacturing defects (MDF not covered under warranty)",
      "STORAGE SPACE: 920 Litres",
    ],
  },
  {
    id: 12,
    name: "Computer Writing Desk",
    category: "Furniture",
    title:
      "Madesa Home Office Computer Writing Desk with 3 Drawers, 1 Door and 1 Storage Shelf, Wood, 136 W x 77 H x 45 D Cm – Grey",
    rating: "★★★★✰",
    price: "11,999",
    mrp: "22,999",
    discount: "48%",
    isEMI: true,
    EMI: "582",
    delivery_day: "17 - 18 January",
    is360: false,
    specs: [
      { title: "Brand", desc: "Madesa" },
      { title: "Product Dimensions", desc: "45D x 136W x 77H Centimeters" },
      { title: "Colour", desc: "Grey" },
      { title: "Style", desc: "Modern" },
      { title: "Finish Type", desc: "	Painted" },
      { title: "Material", desc: "Wood" },
    ],
    about: [
      "The Madesa Office Desk offers a wide tabletop, a shelf to quickly store book and acessories, as well as three drawers and a large cabinet. Every detail of this furniture is made with practicality, comfort and durability in mind, without missing a beautiful esthetic.",
      "The Office Desk is made with Eco-Friendly Engineered Wood and has a paited finish. The back of the desk is NOT painted.",
      "Size: 136 Centimeters of Width, 45 Centimeters of Depth, 77 Centimeters of Height",
      "At Madesa, the client's satisfaction is our purpose. We are here to support you before and after the purchase. If you come across any problem with our products, please feel free to contact us at anytime on Amazon.",
      "Finish : Veneer, Share : Rectangular",
    ],
  },
  {
    id: 13,
    name: "OnePlus Nord",
    category: "Mobile & Accessories",
    title: "OnePlus Nord CE 3 Lite 5G (Chromatic Gray, 8GB RAM, 256GB Storage)",
    rating: "★★★★✰",
    price: "21,999",
    mrp: "59,991",
    discount: "21%",
    isEMI: true,
    EMI: "1,067",
    delivery_day: "Tomorrow, 11 January",
    is360: false,
    specs: [
      { title: "Brand", desc: "OnePlus" },
      { title: "Model Name", desc: "Nord CE 3 Lite 5G" },
      {
        title: "Network Service Provider",
        desc: "Unlocked for All Carriers",
      },
      { title: "Operating System", desc: "OxygenOS" },
      { title: "Cellular Technology", desc: "5G" },
    ],
    about: [
      "Camera: 108 MP Main Camera with EIS; 2MP Depth-Assist Lens and 2MP Macro Lens; Front (Selfie) Camera: 16MP",
      "Rear Camera Mode: Hi-res 108MP mode, 3x Lossles Zoom, Photo, Video, Nightscape, Expert, Panoramic, Portrait, Macro, Time-lapse, Slow-motion, Long exposure, Dual-view video, Text Scanner, 1080p/720p@30fps, Video zoom: 1080P@30fps, 720P@30fps, Slow motion: 720P@120fps, Time-Lapse: 1080P@30fps, Steady Video EIS support",
      "Display: 6.72 Inches; 120 Hz Adaptive refresh rate; FHD+(1080×2400), Colors: 16.7 Million colors, 391 ppi, Aspect Ratio: 20:9, Brightness: 550 nits (typical), 680 nits (HBM)",
      "Operating System: Oxygen OS based on Android 13.1",
      "Processor: Qualcomm Snapdragon 695 5G",
      "Battery & Charging: 5000 mAh with 67W SUPERVOOC Endurance Edition",
    ],
  },
  {
    id: 14,
    name: "realme narzo",
    category: "Mobile & Accessories",
    title:
      "realme narzo N53 (Feather Black, 8GB+128GB) 33W Segment Fastest Charging | Slimmest Phone in Segment | 90 Hz Smooth Display",
    rating: "★★★★✰",
    price: "11,999",
    mrp: "13,999",
    discount: "14%",
    isEMI: true,
    EMI: "582",
    delivery_day: "Tomorrow, 11 January",
    is360: false,
    specs: [
      { title: "Brand", desc: "realme" },
      { title: "Model Name", desc: "realme narzo N53" },
      {
        title: "Network Service Provider",
        desc: "Unlocked for All Carriers",
      },
      { title: "Operating System", desc: "Android 13.0" },
      { title: "Cellular Technology", desc: "4G" },
    ],
    about: [
      "Enjoy smooth multitasking and effortless app switching with the powerful 8GB dynamic RAM. Store all your favorite apps, photos, and files with the generous 128 GB ROM",
      "Experience lightning-fast charging with the 33W SUPERVOOC technology, getting your device ready in no time. Say goodbye to long charging times and stay powered up for longer durations.",
      "The slim and sleek 7.49mm design adds a touch of elegance to your device, making it comfortable to hold and carry. The feather gold design enhances the visual appeal, giving your phone a premium and luxurious look.",
      "Capture stunning, detailed photos with the high-resolution 50MP AI camera, bringing your memories to life.The AI-powered camera technology ensures intelligent scene recognition and enhances your photography skills.",
      "Stay connected and productive for extended periods with the massive 5000mAh battery, eliminating the need for frequent recharging. Enjoy long hours of entertainment, gaming, and browsing without worrying about running out of battery power.",
    ],
  },
  {
    id: 15,
    name: "Apple MacBook Air",
    category: "Computers & Categories",
    title:
      "Apple 2022 MacBook Air Laptop with M2 chip: 34.46 cm (13.6-inch) Liquid Retina Display, 8GB RAM, 256GB SSD Storage, Backlit Keyboard, 1080p FaceTime HD Camera. Works with iPhone/iPad; Midnight",
    rating: "★★★★✰",
    price: "1,02,990",
    mrp: "1,14,900",
    discount: "10%",
    isEMI: true,
    EMI: "4,994",
    delivery_day: "Tomorrow, 15 January",
    is360: true,
    specs: [
      { title: "Brand", desc: "Apple" },
      { title: "Model Name", desc: "MacBook Air" },
      {
        title: "Screen Size",
        desc: "13.6",
      },
      { title: "Hard Disk", desc: "256 GB" },
      { title: "RAM", desc: "8 GB" },
      { title: "Operating System", desc: "Mac OS" },
    ],
    about: [
      "STRIKINGLY THIN DESIGN : The redesigned MacBook Air is more portable than ever and weighs just 1.24 kg (2.7 pounds). Its the ultra-capable laptop that lets you work, play or create just about anything — anywhere.",
      "SUPERCHARGED BY M2 : Get more done faster with a next-generation 8-core CPU, up to 10-core GPU and up to 24GB of unified memory.",
      "UP TO 18 HOURS OF BATTERY LIFE : Go all day and into the night, thanks to the power-efficient performance of the Apple M2 chip.",
      "BIG, BEAUTIFUL DISPLAY : The 34.46-centimetre (13.6-inch) Liquid Retina display features over 500 nits of brightness, P3 wide colour and support for one billion colours for vibrant images and incredible detail.",
      "ADVANCED CAMERA AND AUDIO : Look sharp and sound great with a 1080p FaceTime HD camera, three-mic array and four-speaker sound system with Spatial Audio.",
    ],
  },
];

export { products, productsCategories, generateRandomArray };
